import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-number',
    templateUrl: './number.component.html',
    styleUrls: ['./number.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NumberComponent extends InputComponent {
    protected getValidators(): any[] {
        const validators = super.getValidators();
        const meta = this.meta();

        if (meta) {
            if (meta.min) {
                validators.push(Validators.min(meta.min));
            }
            if (meta.max) {
                validators.push(Validators.max(meta.max));
            }
        }
        return validators;
    }
}
